<div class="vertical">
  <form nz-form [formGroup]="validateForm" [nzLayout]="'vertical'">
    <nz-form-item>
      <nz-form-label nzRequired nzFor="text">{{ title }}</nz-form-label>
      <nz-form-control nzErrorTip="The input is not valid.">
        <textarea nz-input formControlName="text" id="text" [placeholder]="placeHolder"></textarea>
      </nz-form-control>
    </nz-form-item>
  </form>
  @if (descriptionMarkdown) {
    <div class="description" [innerHTML]="descriptionMarkdown | markdownIt"></div>
  }
  <app-save-and-cancel-buttons (cancel)="onCancelClick()" (save)="onSaveClick()"></app-save-and-cancel-buttons>
</div>
